import React, { useState } from 'react';
import {
  Button,
  MenuTrigger,
  Menu,
  MenuItem,
  MenuSeparator,
} from '@backstage/ui';
import {
  RiFileCopyLine,
  RiSearchEyeLine,
  RiDeleteBinLine,
} from '@remixicon/react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';

interface EntityContextMenuProps {
  onInspect: () => void;
  onUnregister: () => void;
}

export const EntityContextMenu = ({
  onInspect,
  onUnregister,
}: EntityContextMenuProps) => {
  const { t } = useTranslationRef(appTranslationRef);
  const [copied, setCopied] = useState(false);

  const handleAction = async (key: React.Key) => {
    switch (key) {
      case 'copy-url':
        await navigator.clipboard.writeText(window.location.href);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
        break;
      case 'inspect':
        onInspect();
        break;
      case 'unregister':
        onUnregister();
        break;
      default:
        break;
    }
  };

  return (
    <MenuTrigger>
      <Button
        size="small"
        variant="tertiary"
        aria-label={t('entityLayout.contextMenu.more')}
      >
        ···
      </Button>
      <Menu placement="bottom end" onAction={handleAction}>
        <MenuItem id="copy-url" iconStart={<RiFileCopyLine size={16} />}>
          {copied
            ? t('entityLayout.contextMenu.copied')
            : t('entityLayout.contextMenu.copyUrl')}
        </MenuItem>
        <MenuItem id="inspect" iconStart={<RiSearchEyeLine size={16} />}>
          {t('entityLayout.contextMenu.inspect')}
        </MenuItem>
        <MenuSeparator />
        <MenuItem
          id="unregister"
          iconStart={<RiDeleteBinLine size={16} />}
          color="danger"
        >
          {t('entityLayout.contextMenu.unregister')}
        </MenuItem>
      </Menu>
    </MenuTrigger>
  );
};
